import React, { PropsWithChildren, useEffect, useState } from 'react';
import { FloatingModalContainer, FloatingModalContainerProps } from './FloatingModalContainer';
import { FloatingModalContent, FloatingModalContentProps } from './FloatingModalContent';

export interface FloatingModalProps extends FloatingModalContentProps, Omit<FloatingModalContainerProps, 'setOpened'> {
  opened: boolean;
  onClose?: () => void;
  onOpen?: () => void;
}

export const FloatingModal = ({
  canClickOutside = false,
  canCloseEscapeKey = false,
  openerTriggerEvent = 'click',
  trigger,
  onClose,
  onOpen,
  ...props
}: PropsWithChildren<FloatingModalProps>) => {
  const [opened, setOpened] = useState(Boolean(props.opened));

  useEffect(() => {
    if (props.opened !== undefined) {
      setOpened(props.opened);
      props.opened ? onOpen?.() : onClose?.();
    }
  }, [props.opened]);

  useEffect(() => {
    opened ? onOpen?.() : onClose?.();
  }, [opened]);

  return (
    <FloatingModalContainer
      position={props.position}
      canCloseEscapeKey={canCloseEscapeKey}
      canClickOutside={canClickOutside}
      openerTriggerEvent={openerTriggerEvent}
      trigger={trigger}
      setOpened={setOpened}
      opened={opened}
    >
      <FloatingModalContent
        {...props}
        opened={opened}
        onCancel={() => {
          setOpened(false);
          onClose?.();
        }}
      />
    </FloatingModalContainer>
  );
};
